import axios from 'axios'
import { EVENT_SUPPLIER_PERSONNEL_REQUEST, USER_TOKEN } from "./CONSTANTS";

export const getEventSupplierPersonnelRequests = (uniqueKey) => {
  console.info("eventSupplierPersonnelRequestServices > getEventSupplierPersonnelRequests...");
  return new Promise((resolve, reject) => {
      axios
      .get(EVENT_SUPPLIER_PERSONNEL_REQUEST()+"?uniqueKey="+uniqueKey,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const addEventSupplierPersonnelRequests = (model) => {
  console.info("eventSupplierPersonnelRequestServices > addEventSupplierPersonnelRequests...");
  return new Promise((resolve, reject) => {
      axios
      .post(EVENT_SUPPLIER_PERSONNEL_REQUEST(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const updateEventSupplierPersonnelRequests = (model) => {
  console.info("updateSupplierPersonnelRequestServices > updateEventSupplierPersonnelRequests...");
  return new Promise((resolve, reject) => {
      axios
      .put(EVENT_SUPPLIER_PERSONNEL_REQUEST(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const deleteEventSupplierPersonnelRequests = (uniqueKey) => {
  console.info("eventSupplierPersonnelRequestServices > deleteEventSupplierPersonnelRequests...");
  return new Promise((resolve, reject) => {
      axios
      .delete(EVENT_SUPPLIER_PERSONNEL_REQUEST()+'/'+uniqueKey,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};